module.exports = __webpack_public_path__ + "static/media/1.1cb4800f.png";